import { render, staticRenderFns } from "./CustomerThanksPage.vue?vue&type=template&id=4e50dff0&"
import script from "./CustomerThanksPage.vue?vue&type=script&lang=js&"
export * from "./CustomerThanksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports